import React, { useState } from "react";
import { getSegments, getPortraits, createSegment, updateSegment, deleteSegment } from "../api/services";
import { useData } from "../hooks/useData";
import { Card, Loading, Button } from "../components/common/UI";
import { IconPlus, IconTrash } from "../components/common/Icons";
import Modal from "../components/common/Modal";
import AudiencePortraits from "../components/common/AudiencePortraits";
import { fmtKop, fmtNum } from "../utils/format";
import styles from "./pages.module.css";

const empty = { name: "", description: "", size_estimate: 0, revenue_kop: 0, color: "#4f7cff" };

export default function Segments() {
  const { data, loading, reload } = useData(getSegments, []);
  const portraits = useData(getPortraits, []);
  const [modal, setModal] = useState(null);

  const save = async () => {
    const { id, ...body } = modal;
    body.size_estimate = Number(body.size_estimate) || 0;
    body.revenue_kop = Math.round(Number(body.revenue_kop) || 0);
    if (id) await updateSegment(id, body);
    else await createSegment(body);
    setModal(null);
    reload();
  };
  const remove = async () => {
    await deleteSegment(modal.id);
    setModal(null);
    reload();
  };

  if (loading || !data) return <Loading />;
  const segs = data.segments || [];

  return (
    <div className={styles.page}>
      <div className={styles.pageHead}>
        <div>
          <h1 className={styles.pageTitle}>Сегменты ЦА</h1>
          <div className={styles.pageSub}>
            Портреты аудитории по продуктам — на основе реальных данных (регистрации, активность, платежи)
          </div>
        </div>
        <Button onClick={() => setModal({ ...empty })}><IconPlus width={16} height={16} /> Новый сегмент</Button>
      </div>

      {portraits.loading ? <Loading /> : <AudiencePortraits data={portraits.data} />}

      {segs.length > 0 && (
        <div style={{ color: "var(--text-dim)", fontSize: 13, fontWeight: 600, marginTop: 8 }}>
          Свои сегменты
        </div>
      )}
      {segs.length === 0 ? null : (
        <div className={styles.grid3}>
          {segs.map((s) => (
            <Card key={s.id}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                <span style={{ width: 10, height: 10, borderRadius: 3, background: s.color }} />
                <b style={{ fontSize: 15 }}>{s.name}</b>
              </div>
              <div style={{ color: "var(--text-dim)", fontSize: 12.5, minHeight: 34, marginBottom: 12 }}>{s.description}</div>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                <span style={{ color: "var(--text-dim)" }}>Размер</span><b>{fmtNum(s.size_estimate)}</b>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}>
                <span style={{ color: "var(--text-dim)" }}>Выручка</span><b>{fmtKop(s.revenue_kop, { short: true })}</b>
              </div>
              <Button variant="ghost" onClick={() => setModal({ ...s, revenue_kop: s.revenue_kop })}>Изменить</Button>
            </Card>
          ))}
        </div>
      )}

      {modal && (
        <Modal
          title={modal.id ? "Сегмент" : "Новый сегмент"}
          onClose={() => setModal(null)}
          footer={
            <>
              {modal.id && <Button variant="danger" onClick={remove}><IconTrash width={15} height={15} /> Удалить</Button>}
              <Button variant="ghost" onClick={() => setModal(null)}>Отмена</Button>
              <Button onClick={save}>Сохранить</Button>
            </>
          }
        >
          <div className={styles.field}>
            <label>Название</label>
            <input value={modal.name} onChange={(e) => setModal({ ...modal, name: e.target.value })} autoFocus />
          </div>
          <div className={styles.field}>
            <label>Описание</label>
            <textarea rows={2} value={modal.description} onChange={(e) => setModal({ ...modal, description: e.target.value })} />
          </div>
          <div className={styles.formRow}>
            <div className={styles.field}>
              <label>Оценка размера (чел.)</label>
              <input type="number" value={modal.size_estimate} onChange={(e) => setModal({ ...modal, size_estimate: e.target.value })} />
            </div>
            <div className={styles.field}>
              <label>Выручка, копейки</label>
              <input type="number" value={modal.revenue_kop} onChange={(e) => setModal({ ...modal, revenue_kop: e.target.value })} />
            </div>
          </div>
          <div className={styles.field}>
            <label>Цвет</label>
            <input type="color" value={modal.color} onChange={(e) => setModal({ ...modal, color: e.target.value })} style={{ height: 40, padding: 4 }} />
          </div>
        </Modal>
      )}
    </div>
  );
}
